import { render, staticRenderFns } from "./button-base.vue?vue&type=template&id=208432fc&scoped=true&"
import script from "./button-base.vue?vue&type=script&lang=ts&"
export * from "./button-base.vue?vue&type=script&lang=ts&"
import style0 from "./button-base.vue?vue&type=style&index=0&id=208432fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208432fc",
  null
  
)

export default component.exports